<template>
  <div class="container py-5">
    <h2 class="mb-4">Painel Administrativo</h2>

    <div class="accordion my-4" id="manualAdmin">
      <div class="accordion-item">
        <h2 class="accordion-header" id="headingOne">
          <button
            class="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseOne"
            aria-expanded="true"
            aria-controls="collapseOne"
          >
            📘 Manual do Administrador
          </button>
        </h2>
        <div
          id="collapseOne"
          class="accordion-collapse collapse"
          aria-labelledby="headingOne"
          data-bs-parent="#manualAdmin"
        >
          <div class="accordion-body">
            <ul>
              <li><strong>Acessar o Painel:</strong> clique em “Painel” no menu superior.</li>
              <li><strong>Publicar uma nova vaga:</strong> vá até “Nova Vaga” no menu ou clique em "+ Nova Vaga" no Painel.</li>
              <li><strong>Editar vaga existente:</strong> clique em “Editar” ao lado da vaga na tabela.</li>
              <li><strong>Excluir vaga:</strong> clique em “Excluir” para removê-la permanentemente.</li>
              <li><strong>Ver candidatos por vaga:</strong> clique em “Candidatos” ao lado de uma vaga para ver quem se inscreveu.</li>
              <li><strong>Baixar currículos:</strong> use o botão “Ver Currículo” na tabela de candidatos.</li>
              <li><strong>Status da vaga:</strong> “aberta” permite candidaturas; “encerrada” apenas exibição.</li>
            </ul>
            <p class="mt-3">
              <strong>Dica:</strong> mantenha as vagas atualizadas e feche as vagas antigas para manter o sistema organizado porém com histórico.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="mb-0">Vagas Publicadas</h5>
      <router-link to="/admin/nova-vaga" class="btn btn-success">+ Nova Vaga</router-link>
    </div>

    <!-- Filtro de título -->
    <div class="mb-3" style="max-width: 350px;">
      <div class="input-group input-group-sm">
        <span class="input-group-text bg-light border-0">
          <i class="bi bi-type"></i>
        </span>
        <input
          v-model="filtroTitulo"
          class="form-control border-0 shadow-none py-4"
          style="background: #f8f9fa"
          placeholder="Filtrar por título"
        />
        <button
          v-if="filtroTitulo"
          class="btn btn-light border-0 px-2"
          type="button"
          @click="filtroTitulo=''"
          title="Limpar filtro"
          style="margin-left:-2px"
        >
          <i class="bi bi-x-circle text-secondary"></i>
        </button>
      </div>
    </div>

    <div v-if="vagasFiltradas.length" class="table-responsive">
      <table class="table table-bordered table-striped align-middle">
        <thead class="table-light">
          <tr>
            <th>Título</th>
            <th>Status</th>
            <th>Data de publicação</th>
            <th>Prazo</th>
            <th>Candidatos</th>
            <th>Aprovado(s)</th>
            <th style="width: 480px;">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="vaga in vagasFiltradas" :key="vaga.id">
            <td>{{ vaga.titulo }}</td>

            <td>
              <span v-if="vaga.statuss === 'aberta'" class="badge bg-success">Aberta</span>
              <span v-else class="badge bg-danger">Encerrada</span>
            </td>

            <td>{{ new Date(vaga.data_publicacao).toLocaleDateString() }}</td>

            <td>
              {{ vaga.prazo ? new Date(vaga.prazo).toLocaleDateString('pt-BR') : '-' }}
            </td>

            <td>
              {{ vaga.total_candidatos ?? 0 }}
            </td>

            <!-- NOVA COLUNA -->
            <td>
              <span v-if="vaga.aprovado && vaga.aprovado.trim()">
                {{ vaga.aprovado }}
              </span>
              <span v-else class="text-muted">—</span>
            </td>

            <td>
              <div class="d-flex gap-1">
                <router-link
                  :to="`/vaga/${vaga.id}`"
                  class="d-flex justify-content-center align-items-center btn btn-sm btn-outline-info me-1"
                >
                  Ver Vaga
                </router-link>

                <router-link
                  :to="`/admin/vaga/${vaga.id}/candidatos`"
                  class="d-flex justify-content-center align-items-center btn btn-sm btn-outline-primary me-1"
                >
                  Candidatos
                </router-link>

                <router-link
                  :to="`/admin/vaga/${vaga.id}/editar`"
                  class="d-flex justify-content-center align-items-center btn btn-sm btn-outline-warning me-1"
                >
                  Editar
                </router-link>

                <button
                  class="d-none justify-content-center align-items-center btn btn-sm btn-outline-danger"
                  @click="excluir(vaga.id)"
                >
                  Excluir (não recomendado)
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <p v-else class="text-muted">Nenhuma vaga cadastrada.</p>
  </div>
</template>

<script>
import api from '../services/api';

export default {
  name: "AdminDashboardVie",
  data() {
    return {
      vagas: [],
      filtroTitulo: ''
    };
  },
  computed: {
    vagasFiltradas() {
      if (!this.filtroTitulo) return this.vagas;
      return this.vagas.filter(v =>
        (v.titulo || '').toLowerCase().includes(this.filtroTitulo.toLowerCase())
      );
    }
  },
  mounted() {
    this.carregarVagas();
  },
  methods: {
    async carregarVagas() {
      try {
        const response = await api.get('listar_vagas_admin.php');
        this.vagas = response.data;
      } catch (error) {
        alert('Erro ao carregar vagas.');
        console.error(error);
      }
    },
    async excluir(vagaId) {
      if (!confirm('Tem certeza que deseja excluir esta vaga?')) return;

      try {
        await api.post('excluir_vaga.php', { vaga_id: vagaId });
        this.vagas = this.vagas.filter(v => v.id !== vagaId);
        alert('Vaga excluída com sucesso!');
      } catch (error) {
        alert('Erro ao excluir vaga.');
      }
    },
  },
};
</script>
